import React from "react";
import { DataContextTestProvider } from "../context/DataContext.jsx";
import JobsList from "../apps/jobs/views/JobsList.jsx";
import { C, font } from "../lib/styles.js";

// Local-only verification harness for the Jobs LIST (Active/Archive/Trash) at
// ?e2e=jobslist on localhost (see main.jsx). No auth, no real data. JobsList reads
// only { jobs, trashedJobs, restoreJob, permanentDeleteJob, jobsError, loaded } from
// the data layer, so a mock context value is enough to render the real component.

const JOBS = [
  { id: "j1", clientName: "Acme Arts LLC", jobId: "acmarts_260520", status: "scheduled", createdAt: "2026-05-20", grossRevenue: 12450 },
  { id: "j2", clientName: "Booked Brand Inc", jobId: "bookbrand_260518", status: "in_progress", createdAt: "2026-05-18", grossRevenue: 8200 },
  { id: "j3", clientName: "Studio Northside", jobId: "studnorth_260515", status: "processing", createdAt: "2026-05-15", grossRevenue: 5400 },
  { id: "j4", clientName: "Gallery Verde", jobId: "gallverde_260510", status: "delivered", createdAt: "2026-05-10", grossRevenue: 9800, invoiced: true },
  { id: "j5", clientName: "Pier 59 Studios", jobId: "pier59_260505", status: "delivered", createdAt: "2026-05-05", grossRevenue: 15600, invoiced: true, paid: true },
];

const TRASHED = [
  { id: "jt1", clientName: "Cancelled Co", jobId: "cancelco_260401", status: "scheduled", createdAt: "2026-04-01", grossRevenue: 0, deletedAt: "2026-05-01T00:00:00Z" },
];

const value = {
  jobs: JOBS,
  trashedJobs: TRASHED,
  restoreJob: () => {},
  permanentDeleteJob: () => {},
  jobsError: null,
  loaded: true,
};

export default function E2EJobsListFixture() {
  return (
    <DataContextTestProvider value={value}>
      <div className="app-content" style={{ minHeight: "100vh", background: C.bg, fontFamily: font, padding: 24 }}>
        <JobsList user={{ role: "admin" }} onOpenJob={() => {}} />
      </div>
    </DataContextTestProvider>
  );
}
